import { Center, Portal, Spinner } from '@chakra-ui/react';

export const Progress = (props: any) => (
  <>
    {props.show && (
      <Portal>
        <Center
          w="100%"
          h="100%"
          display={"grid"}
          bg="white"
          zIndex="99999"
          pos="absolute"
          top="0"
          opacity="0.8"
        >
          <Spinner
            data-testid="spinner"
            thickness="4px"
            emptyColor="gray.200"
            color="blue.500"
            size="xl"
          />
        </Center>
      </Portal>
    )}
  </>
);
